import React from "react";
import {
    ChecklistItemNoteTextEditorQuillConfig,
    ToolbarButtonConfig,
} from "utilities/quill/quill-config";

const CSS_CLASS_NAME = "c-rich-text-editor";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ChecklistItemNoteRichTextQuillToolbarProps {
    disabled?: boolean;
    id: string;
    displayImageOption?: boolean;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

/**
 * Custom HTML Toolbar for quill. Quill automatically
 * attaches events based on classnames.
 * @param props {ChecklistItemNoteRichTextEditorProps}
 */
const ChecklistItemNoteRichTextQuillToolbar: React.FC<
    ChecklistItemNoteRichTextQuillToolbarProps
> = (props: ChecklistItemNoteRichTextQuillToolbarProps) => {
    const { disabled, id, displayImageOption = true } = props;

    const disabledModifier = disabled ? "-disabled" : "";

    return (
        <div>
            <div
                className={`${CSS_CLASS_NAME}__toolbar ql-toolbar ql-${ChecklistItemNoteTextEditorQuillConfig.theme} ${disabledModifier}`}
                id={id}>
                <span
                    className={
                        ChecklistItemNoteTextEditorQuillConfig
                            .ToolbarButtonClasses.Section
                    }>
                    {ChecklistItemNoteTextEditorQuillConfig.inlineFormats.map(
                        (cfg: ToolbarButtonConfig) => (
                            <button
                                aria-label={cfg.accessibleText}
                                className={`ql-${cfg.format}`}
                                key={`${cfg.format}-${cfg.value}`}
                                value={cfg.value}
                                type="button"
                            />
                        )
                    )}
                </span>
                <span
                    className={
                        ChecklistItemNoteTextEditorQuillConfig
                            .ToolbarButtonClasses.Section
                    }>
                    {displayImageOption && (
                        <button
                            aria-label={"Insert image"}
                            className={
                                ChecklistItemNoteTextEditorQuillConfig
                                    .ToolbarButtonClasses.Image
                            }
                            type={"button"}
                        />
                    )}
                </span>
            </div>
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default ChecklistItemNoteRichTextQuillToolbar;

// #endregion Exports
